import React, { useState, useEffect, forwardRef } from 'react';
import Label from "components/general/Label";
import CaptionTable from 'components/general/table/CaptionTable';
import Status from 'components/presentation/Status';
import { CompetitionFromStore } from 'helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faCaretDown, faPlusCircle, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { Collapse } from 'react-bootstrap';

import EquDressageIndividual from './EquDressageIndividual';

const competition = CompetitionFromStore();
const iconClose = competition === 'EG2023' ? faMinusCircle : faCaretDown;
const iconOpen = competition === 'EG2023' ? faPlusCircle : faCaretRight;

const arrowDown = <FontAwesomeIcon icon={iconClose} />
const arrowUp = <FontAwesomeIcon icon={iconOpen} />


function EquDressageIndividualCollapse({ data }) {
  const resultStatus = data?.results?.status?.code;
  const scheduleStatus = data?.results?.schedule?.status?.code;

  const [open, setOpen] = useState(false);
  const [arrow, setArrow] = useState(arrowUp);
  const [openAll, setOpenAll] = useState(true);

  useEffect(() => {
    if (openAll) {
      setArrow(arrowDown)
    } else {
      setArrow(arrowUp)
    }
    setOpen(openAll);
  }, [openAll])

  const handleClick = () => {
    if (open) {
      setArrow(arrowUp)
    } else {
      setArrow(arrowDown)
    }
    setOpen(!open);
  }

  const groups = ['', 'A', 'B', 'C', 'E', 'F', 'G', 'H', 'I', 'J' ]
  const caption = (
    <CaptionTable
      leftCol={<><span className="fw-bold"><Label data="LabelGroup" /> {groups[Number(data?.results?.eventUnitCode?.slice(-5, -4))]}</span></>}
      centerCol=<div></div>
      rightCol={
          <>
              <div className="d-flex">
                  <Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />
                  <div className="arrow ms-3" onClick={(e) => handleClick()}>{arrow}</div>
              </div>
          </>
        }
     />
  )

  // Needed to avoid warning log
  const GroupTable = forwardRef(() => (
      <EquDressageIndividual data={data} hideCaption={true} />
    )
  );

  return (
    <>
      <div className="bg-caption">
          {caption}
      </div>
      <Collapse in={open} >
        <GroupTable />
      </Collapse>       
    </>
  );
}

export default EquDressageIndividualCollapse;
